export default [
  {key: 'Collection', text: 'Collection', value:2},
  {key: 'Week', text: 'Week', value:1},
  {key: 'Month', text: 'Month', value:0}
];